// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 512) return "static/css/512.3c77149ef.chunk.css";
	if (chunkId === 874) return "static/css/874.3c77149ef.chunk.css";
	// return url for filenames based on template
	return undefined;
};